import { GetStaticPathsResult, GetStaticPropsContext, GetStaticPropsResult } from 'next';
import invariant from 'tiny-invariant';

import { getProPageBySlug } from '../../../src/api/contentful/getProPageBySlug';
import { AppLogic } from '../../../src/components/AppLogic/AppLogic';
import { GlobalLayout } from '../../../src/components/Layouts/GlobalLayout';
import { REVALIDATE } from '../../../src/constants/next';
import { IPageMetadata } from '../../../src/interfaces/nextjs';
import { CMSProPage, IProPageProps } from '../../../src/views/CMSProPage/CMSProPage';

type IParams = {
  campaignSlug: string;
  couponCode?: string[];
};

export async function getStaticProps({
  params,
}: GetStaticPropsContext<IParams>): Promise<GetStaticPropsResult<IPageMetadata & IProPageProps>> {
  invariant(params, 'Params not found');

  try {
    const data = await getProPageBySlug(params.campaignSlug);

    const metadata = {
      _page: 'pro-page',
      _pageTitle: 'Pro Page',
      proPageData: data,
    };

    if (params.couponCode?.length) {
      const couponCode = params.couponCode[0];

      return {
        props: {
          ...metadata,
          couponCode,
          _pageSubject: couponCode,
          canonicalPath: `/pro-page/${data.fields.slug}/${couponCode}`,
        },
        revalidate: REVALIDATE.EVERY_MINUTE,
      };
    }

    return {
      props: { ...metadata, canonicalPath: `/pro-page/${data.fields.slug}` },
      revalidate: REVALIDATE.EVERY_MINUTE,
    };
  } catch {
    return {
      redirect: {
        permanent: false,
        destination: `/pro`,
      },
      revalidate: REVALIDATE.EVERY_MINUTE,
    };
  }
}

export async function getStaticPaths(): Promise<GetStaticPathsResult<IParams>> {
  return {
    paths: [],
    fallback: 'blocking',
  };
}

CMSProPage.getLayout = function getLayout(page: any) {
  return (
    <AppLogic pageProps={page.props}>
      <GlobalLayout hasStickyBottomBanner hideStickyBannerGetApp>
        {page}
      </GlobalLayout>
    </AppLogic>
  );
};

export default CMSProPage;
